import ParserRepository from "./ParserRepository";
import RequestHandlerRepository from "./RequestHandlerRepository"

import DomainRepository from "./DomainRepository";
import DomainCategoryRepository from "./DomainCategoryRepository";

import BrandRepository from "./BrandRepository";

import ProxyRepository from "./ProxyRepository";

import JobRepository from "./JobRepository";
import JobHistoryRepository from "./JobHistoryRepository";
import JobSchedulerRepository from "./JobSchedulerRepository";

import OperationLogRepository from "./OperationLogRepository";
import LogRepository from "./LogRepository";

import JobGroupRepository from "./JobGroupRepository";
import JobGroupLogRepository from "./JobGroupLogRepository";

import LocationRepository from "./LocationRepository";
import LocationReportRepository from "./LocationReportRepository";

import PopularitySiteRepository from "./PopularitySiteRepository";
import PopularityDataRepository from "./PopularityDataRepository";

import CountryRepository from "./CountryRepository";

import AuthRepository from './AuthRepository';

const repositories={
    'parser':ParserRepository,
    'request_handler':RequestHandlerRepository,

    'domain':DomainRepository,
    'domain_category':DomainCategoryRepository,

    'brand':BrandRepository,

    'proxy':ProxyRepository,
    
    'job':JobRepository,
    'job_history':JobHistoryRepository,
    'job_scheduler':JobSchedulerRepository,

    'operation_log':OperationLogRepository,
    'log':LogRepository,
    
    'job_group':JobGroupRepository,
    'job_group_log':JobGroupLogRepository,

    'location':LocationRepository,
    'location_report':LocationReportRepository,

    'popularity_site':PopularitySiteRepository,
    'popularity_data':PopularityDataRepository,

    'country':CountryRepository,

    'auth':AuthRepository,
}

export default {
    get: name => repositories[name]
}